// extracted by mini-css-extract-plugin
export default {"spacer":"CheckoutSavedCreditCard-module__spacer___35uX3"};